module.exports = __webpack_public_path__ + "static/img/jiage.48673b52.png";